import Menu from './Compartido/Menu.jsx';
import CabeceraFaqs from './Faqs/CabeceraFaqs.jsx';
import TextosFaqs from './Faqs/TextosFaqs.jsx';
import Footer from './Compartido/Footer.jsx';

const Faqs = (props) => {
    return (
        <main>
            <Menu
                idiomas={props.idiomas}
                lang={props.lang}
                config={props.config}
                ruta={props.ruta}
            />
            <CabeceraFaqs
                ruta={props.ruta}
            />
            <TextosFaqs
                categorias={props.categoriasfaq}
                faqs={props.faqs}
                config={props.config}
                lang={props.lang}
                webconfig={props.websgrupo}
            />
            <Footer
                datos={props.websgrupo}
                config={props.config}
                lang={props.lang}
                ruta={props.ruta}
            />
        </main>
    );
}

export default Faqs;
